import {
  CATALOG_SECTIONS,
  FUSION,
  TRIO,
  DUO,
  ONLY_MOBILE,
  OTHERS,
  ONLY_PHONE,
  MOBILE_PREPAID,
  EQUIPAMIENTO_PRODUCT_OFFERING_TYPE,
  GAME_PASS,
} from "@/constants/constants";

const FUSION_POT = "1";
const MODULAR_MI_MOVISTAR = "2";
export const PREPAGO = "6";
const TELEVISION = "7";
const NETFLIX = "8";
const DISNEY = "9";
const TERMINAL_R2R_ADICIONAL = "10";
const TERMINAL_R2R_INCLUIDO = "11";
const OTROS = "16";
const ISR = "3";
export const SEGUNDA_FIBRA = "33";
const FIBRA_ADICIONAL_ID = "135";

export const checkHasHiredProducts = (hiredProducts) => {
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    return true;
  }
  return false;
};

export const getConvergenteProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    (product) =>
      // product.subseccion ===
      //   CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      (product.productType === FUSION || product.productType === TRIO)
  );

  return filteredProducts;
};

export const getInternetProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    (product) =>
      // product.subseccion ===
      //   CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      (product.productType === FUSION ||
        product.productType === TRIO ||
        product.productType === DUO)
  );

  return filteredProducts;
};

export const getISRProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === DUO &&
      productOfferingTypes.some(({ id }) => id === ISR)
  );

  return filteredProducts;
};
export const checkIfaListContainsProductId = (hiredProducts, poTarget) => {
  if (checkHasHiredProducts(hiredProducts) && poTarget) {
    return hiredProducts.some((x) => x.productId === poTarget);
  }
  return false;
};

export const getSegundaFibraProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === DUO &&
      productOfferingTypes.some(({ id }) => id === SEGUNDA_FIBRA)
  );

  return filteredProducts;
};

export const getFibraAdicionalProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === DUO &&
      productOfferingTypes.some(({ id }) => id === FIBRA_ADICIONAL_ID)
  );

  return filteredProducts;
};

export const getFijoProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === ONLY_PHONE
  );

  return filteredProducts;
};

export const getMobilesProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === ONLY_MOBILE
  );

  return filteredProducts;
};

export const getR2RProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === OTHERS &&
      productOfferingTypes.some(
        ({ id }) =>
          id === TERMINAL_R2R_INCLUIDO || id === TERMINAL_R2R_ADICIONAL
      )
  );

  return filteredProducts;
};

export const getTVProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.COMMUNICATIONS &&
      productType === OTHERS &&
      productOfferingTypes.some(
        ({ id }) => id === TELEVISION || id === DISNEY || id === NETFLIX
      )
  );

  return filteredProducts;
};

export const getAlarmasProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes }) =>
      subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.SECURITY &&
      productType === OTHERS &&
      productOfferingTypes.some(({ id }) => id === OTROS)
  );

  return filteredProducts;
};

export const getProteccioDigitalIntegralProducts = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(
    ({ subseccion, productType, productOfferingTypes, poId }) =>
      // subseccion === CATALOG_SECTIONS.VERTICALS.SUB_SECTIONS.SECURITY &&
      // productType === OTHERS &&
      // productOfferingTypes.some(({ id }) => id === OTROS)
      poId === "3773"
  );

  return filteredProducts;
};

export const getProductsByProductId = (hiredProducts, productId) => {
  let findedProduct = null;

  if (checkHasHiredProducts(hiredProducts)) {
    findedProduct = hiredProducts.find(({ productId: id }) => id === productId);
  }
  return findedProduct;
};

export const getChildProducts = (hiredProducts, productId) => {
  let childProductsFind = null;
  if (
    hiredProducts &&
    Array.isArray(hiredProducts) &&
    hiredProducts.length > 0
  ) {
    hiredProducts.forEach((x) => {
      const childProduct = x.childProductId.find(
        (x) => x.productId === productId
      );
      if (childProduct) {
        childProductsFind = childProduct;
      }
    });
  }

  return childProductsFind;
};

export const getFilters = (misProductosOrionInfo) => {
  const calculateFilterOrder = ({
    poId,
    productOfferingTypes,
    productType,
    subseccion,
  }) => {
    return Math.max(
      subseccion.length > 0 ? 1 : 0,
      productType.length > 0 ? 2 : 0,
      productOfferingTypes.length > 0 ? 3 : 0,
      poId.length > 0 ? 4 : 0
    );
  };

  const filters = misProductosOrionInfo.flatMap(({ rulesList }, index) =>
    rulesList.map(
      ({ poId, productOfferingTypes, productType, subseccion }) => ({
        order: calculateFilterOrder({
          poId,
          productOfferingTypes,
          productType,
          subseccion,
        }),
        poId,
        productOfferingTypes,
        productType,
        subseccion,
        index,
      })
    )
  );

  filters.sort((a, b) => b.order - a.order);
  return filters;
};

export const hiredProductsChecksRulesList = (hiredProducts, rulesList) => {
  let response = true;
  if (Array.isArray(rulesList) && rulesList.length > 0) {
    const rules = [];
    rulesList.forEach((rule) => {
      rules.push({
        poId: rule.data.fields.poId,
        productOfferingTypes: rule.data.fields?.productOfferingTypes,
        productType: rule.data.fields.productType,
        subseccion: rule.data.fields.subseccion,
      });
    });

    const result = getProductsByFilters(rules, hiredProducts);

    Array.isArray(result) && result.length > 0
      ? (response = true)
      : (response = false);
  }

  return response;
};

export const getProductsByFilters = (filters, hiredProducts) => {
  if (filters.length === 0 || hiredProducts.length === 0) {
    return [];
  }

  const tempHiredProducts = [...hiredProducts];
  tempHiredProducts.forEach((product, index) => {
    product.index = index;
  });

  return filters
    .map((filter) => {
      let filtered = [...tempHiredProducts];

      if (Array.isArray(filter.poId) && filter.poId.length > 0) {
        filtered = filtered.filter(
          (tempProduct) =>
            tempProduct.poId && filter.poId.includes(tempProduct.poId)
        );
      }

      if (
        Array.isArray(filter.productOfferingTypes) &&
        filter.productOfferingTypes.length > 0
      ) {
        filtered = filtered.filter((tempProduct) =>
          tempProduct.productOfferingTypes.some(
            (obj) => obj.id && filter.productOfferingTypes.includes(obj.id)
          )
        );
      }

      if (Array.isArray(filter.productType) && filter.productType.length > 0) {
        filtered = filtered.filter(
          (tempProduct) =>
            tempProduct.productType != null &&
            tempProduct.productType !== "" &&
            filter.productType.includes(`${tempProduct.productType}`)
        );
      }

      if (Array.isArray(filter.subseccion) && filter.subseccion.length > 0) {
        filtered = filtered.filter(
          (tempProduct) =>
            tempProduct.subseccion &&
            filter.subseccion.includes(tempProduct.subseccion)
        );
      }

      Array.isArray(filtered) &&
        filtered.length > 0 &&
        filtered.forEach((obj) => {
          tempHiredProducts.splice(
            tempHiredProducts.findIndex(
              (product) => product.index === obj.index
            ),
            1
          );
        });

      return {
        products: filtered,
        filter_index: filter.index,
      };
    })
    .filter((result) => result.products.length > 0);
};

export const calculateProductCardClassname = (
  products,
  productIndex,
  hasISR,
  hasSegundaFibra,
  hasFijo,
  hasFibraAdicional
) => {
  const isFirstProductCard = productIndex === 0;
  const isMobilePhoneProductCard = products.some((obj) =>
    obj.hasOwnProperty("number")
  );

  const countProductCardsBeforeMobilePhoneProductCard = [
    hasISR,
    hasSegundaFibra,
    hasFibraAdicional,
    hasFijo,
  ].filter((clientHasProductCard) => clientHasProductCard === true).length;
  const countProductCardsIsOdd =
    countProductCardsBeforeMobilePhoneProductCard % 2 === 0;

  if (
    (isFirstProductCard && countProductCardsIsOdd) ||
    isMobilePhoneProductCard
  ) {
    return "width-100";
  }
  return "";
};

// utils / mismo archivo / arriba del componente
const resolveProductsForTvMenu = (tvMenu, TvParents, filteredResults) => {
  // Si hay más de un TvParent → usar TvParents siempre
  const hasMultipleTvParents = TvParents.length > 1;

  // Lógica: usar TvParents cuando:
  // - es tvMenu
  // - filteredResults.length === 1
  // - el producto NO tiene tipo 51
  const shouldUseTvParents = (() => {
    if (!tvMenu) return false;
    if (!Array.isArray(filteredResults) || filteredResults.length !== 1)
      return false;

    const product = filteredResults[0];

    const isNot51 = !product.productOfferingTypes?.some(
      type => type.id === "51"
    );

    return isNot51;
  })();

  return (hasMultipleTvParents || shouldUseTvParents)
    ? TvParents
    : filteredResults;
};


export const addFiltersResultsToProductCards = (
  boxes,
  results,
  tvMenu = false
) => {
  const updatedBoxes = boxes.map((box, index) => {
    let filteredResults = results
      .filter((result) => index === result.filter_index)
      .flatMap((result) => result.products);

    let url = null;

    if (filteredResults.length === 1) {
      if (
        box.showDetail &&
        !filteredResults.some((obj) => obj.hasOwnProperty("number"))
      ) {
        url = `${box.url}/detalle?productId=${filteredResults[0].productId}`;
      } else {
        url = box.url;
      }
    } else if (filteredResults.length >= 2 || !box.showDetail) {
      url = box.url;
    }

    const TvParents = filteredResults.filter(
      (elem) =>
        elem.productOfferingTypes.length === 1 &&
        elem.productOfferingTypes.some((obj) => obj.id === "7")
    );

    if (TvParents.length === 1) {
      url = `${box.url}/detalle?productId=${TvParents[0].productId}`;
    } else if (TvParents.length > 1) {
      filteredResults = TvParents;
      url = box.url;
    }

    return {
      ...box,
      products: resolveProductsForTvMenu(tvMenu, TvParents, filteredResults),
      url: url,
    };
  });

  return updatedBoxes;
};

export const hasDisneyProduct = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return false;

  const filteredProducts = hiredProducts.filter(({ productOfferingTypes }) =>
    productOfferingTypes.some(id === DISNEY)
  );

  return filteredProducts.length > 0 ? true : false;
};

export const checkHasContractProduct = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return false;

  return hiredProducts.some(({ productType }) => productType !== MOBILE_PREPAID);
};

export const hasConvergenteProduct = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return false;

  const filteredProducts = hiredProducts.filter(({ productOfferingTypes }) =>
    productOfferingTypes.some(({ id }) => `${id}` === "1" || `${id}` === "2")
  );

  return filteredProducts.length > 0 ? true : false;
};

export const checkHasPrepagoLine = (hiredProducts) => {
  return Array.isArray(hiredProducts) &&
    hiredProducts.some(product =>
      Array.isArray(product.productOfferingTypes) &&
      product.productOfferingTypes.some(({ id }) => id === PREPAGO)
    );
};

export const getPrepagoLines = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return [];

  const filteredProducts = hiredProducts.filter(({ productOfferingTypes }) =>
    productOfferingTypes.some(({ id }) => id === PREPAGO)
  );

  return filteredProducts;
};

export const checkHasOldDisneyPark = (hiredProducts) => {
  return Array.isArray(hiredProducts) && hiredProducts.some((product) => product?.hasOldDisneyPark === true);
};

export const checkLinkAddAditionalLine = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return false;
  const filteredProducts = hiredProducts.filter(
    (product) =>
      product.productType === FUSION || product.productType === ONLY_MOBILE
  );
  return filteredProducts && filteredProducts.length > 0;
};

export const checkPaintAddAditionalLine = (hiredProducts) => {
  if (!Array.isArray(hiredProducts)) return false;
  const filteredProducts = hiredProducts.filter(
    (product) => product.productType === DUO
  );
  return filteredProducts && filteredProducts.length > 0;
};

export const getEquipamientoProducts = (
  hiredProducts,
  reverseFilter = false
) => {
  const filteredProducts = hiredProducts.filter(({ productOfferingTypes }) =>
    reverseFilter
      ? !productOfferingTypes.some(({ id }) =>
          EQUIPAMIENTO_PRODUCT_OFFERING_TYPE.includes(id)
        )
      : productOfferingTypes.some(({ id }) =>
          EQUIPAMIENTO_PRODUCT_OFFERING_TYPE.includes(id)
        )
  );

  return filteredProducts;
};

export const hasCommunicationProducts = ({ hiredProducts = [], hiredProductsList = [] } = {}) => {
  if (!Array.isArray(hiredProducts) || !Array.isArray(hiredProductsList)) {
    return false;
  }

  const filteredProducts = hiredProductsList.filter(
    ({ productType } = {}) =>
      productType !== GAME_PASS && productType !== OTHERS
  );

  const hasFilteredProducts = filteredProducts.length > 0;
  const hasR2RProducts = Boolean(getR2RProducts(hiredProducts));

  return hasFilteredProducts || hasR2RProducts;
};
